import store from '@/store'
import { SET_FORM_DATA, SET_TERMS_ACCEPTED } from '@/store/modules/register.module'
import { computed } from '@vue/composition-api'

export const useFormFields = () => {
  const firstName = computed({
    get() {
      return store.state.register.formData.firstName
    },
    set(value) {
      store.commit(SET_FORM_DATA, { firstName: value })
    },
  })
  const lastName = computed({
    get() {
      return store.state.register.formData.lastName
    },
    set(value) {
      store.commit(SET_FORM_DATA, { lastName: value })
    },
  })
  const country = computed({
    get() {
      return store.state.register.formData.country
    },
    set(value) {
      store.commit(SET_FORM_DATA, { country: value })
    },
  })
  const phone = computed({
    get() {
      return store.state.register.formData.phone
    },
    set(value) {
      store.commit(SET_FORM_DATA, { phone: value })
    },
  })
  const companyName = computed({
    get() {
      return store.state.register.formData.companyName
    },
    set(value) {
      store.commit(SET_FORM_DATA, { companyName: value })
    },
  })
  const companyRole = computed({
    get() {
      return store.state.register.formData.companyRole
    },
    set(value) {
      store.commit(SET_FORM_DATA, { companyRole: value })
    },
  })

  const selectedLaunchDate = computed({
    get() {
      return store.state.register.formData.selectedLaunchDate
    },
    set(value) {
      store.commit(SET_FORM_DATA, { selectedLaunchDate: value })
    },
  })

  const email = computed({
    get() {
      return store.state.register.formData.email
    },
    set(value) {
      store.commit(SET_FORM_DATA, { email: value })
    },
  })

  const password = computed({
    get() {
      return store.state.register.formData.password
    },
    set(value) {
      store.commit(SET_FORM_DATA, { password: value })
    },
  })

  const termsAccepted = computed({
    get() {
      return store.state.register.termsAccepted
    },
    set(value) {
      store.commit(SET_TERMS_ACCEPTED, value)
    },
  })

  return {
    firstName,
    lastName,
    country,
    phone,
    companyName,
    companyRole,
    selectedLaunchDate,
    email,
    password,
    termsAccepted,
  }
}
